<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6><a href="javascript:void(0)" class="text-info" @click="back()"> <i class="fas fa-arrow-left"></i></a> အကောင့် ထည့်ရန် <small>(Fields in red are required)</small></h6>
					</div>
					<div class="card-body">
						<form v-on:submit.prevent="onSubmit">
							<div class="form-group row">
								<label for="inputRoleId" class="col-sm-2 col-form-label text-danger">ခွင်ပြုချက်</label>
								<div class="col-sm-10">
									<select id="inputRoleId" class="form-control" v-model="accountRequest.roleId" @change="validationRule()">
										<option value="">ရွေးချယ်မည်</option>
										<option v-for="role in roleList" :value="role.id">{{role.name}}</option>
									</select>
									<small class="text-danger">{{validationData.roleId}}</small>
								</div>
							</div>
							<div class="form-group row">
								<label for="inputShopId" class="col-sm-2 col-form-label text-danger">ဆိုင်ခွဲ</label>
								<div class="col-sm-10">
									<select id="inputShopId" class="form-control" v-model="accountRequest.shopId" @change="validationRule()">
										<option value="">ရွေးချယ်မည်</option>
										<option v-for="shop in shopList" :value="shop.id">{{shop.name}}</option>
									</select>
									<small class="text-danger">{{validationData.shopId}}</small>
								</div>
							</div>
							<div class="form-group row">
								<label for="inputName" class="col-sm-2 col-form-label text-danger">အကောင့် နာမည်</label>
								<div class="col-sm-10">
									<input type="text" v-model="accountRequest.name" @blur="validationRule()"
										class="form-control" id="inputName">
									<small class="text-danger">{{validationData.name}}</small>
								</div>
							</div>
							<div class="form-group row">
								<label for="inputEmail" class="col-sm-2 col-form-label text-danger">အီးမေးလ်</label>
								<div class="col-sm-10">
									<input type="email" v-model="accountRequest.email" @blur="validationRule()"
										class="form-control" id="inputEmail">
									<small class="text-danger">{{validationData.email}}</small>
								</div>
							</div>
							<div class="form-group row">
								<label for="inputPassword" class="col-sm-2 col-form-label text-danger">လျှို့ဝှက်စကား</label>
								<div class="col-sm-10">
									<input type="password" v-model="accountRequest.password" @blur="validationRule()"
										class="form-control" id="inputPassword">
									<small class="text-danger">{{validationData.password}}</small>
								</div>
							</div>
							<div class="form-group row">
								<label for="inputConfirmPassword" class="col-sm-2 col-form-label text-danger">လျှို့ဝှက်စကား နောက်တစ်ကြိမ်</label>
								<div class="col-sm-10">
									<input type="password" v-model="accountRequest.confirm" @blur="validationRule()"
										class="form-control" id="inputConfirmPassword">
									<small class="text-danger">{{validationData.confirm}}</small>
								</div>
							</div>

							<button type="submit" class="btn btn-primary float-save">လုပ်ဆောင်မည်</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'accountCreate',
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				filter: {
					page: "",
                    reverse: "",
                    sort: "",
                    name: "",
				},
				shopList : [],
				roleList : [],
				accountRequest: {
					id: "",
					roleId: "",
					shopId: "",
					name: "",
					email: "",
					password: ""
				},
				validationData: {
					roleId: "",
					shopId: "",
					name: "",
					email: "",
					password: ""
				}
			}
		},
		watch: {
			async $route(to, from) {
				if (to.params.id) {
					this.accountRequest.id = to.params.id
					await this.accountDetail()
				}
			},
		},
		computed: {},
		methods: {
			...mapActions({
				accountUpdateAction: 'accountUpdateAction',
				accountFieldsAction: 'accountFieldsAction',
			}),
			back() {
				this.$router.replace({ path: 'account-list', query: { page: this.filter.page, reverse: this.filter.reverse, sort: this.filter.sort, name: this.filter.name} }).catch(()=>{})
			},
			async getFields(){
				let option = {
					fields: {id: this.accountRequest.id, type: "update"}
				}
				await this.accountFieldsAction({
					...option
				}).then(res => {
					this.shopList = res.data.data.shop
					this.roleList = res.data.data.role
					this.accountRequest.id = res.data.data.account.id
					this.accountRequest.roleId = res.data.data.account.role
					this.accountRequest.shopId = res.data.data.account.shop_id
					this.accountRequest.name = res.data.data.account.name
					this.accountRequest.email = res.data.data.account.email
				}).catch(err => this.isLoading = true)
			},
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
				let option = this.accountRequest
				await this.accountUpdateAction({
					...option
				}).then(res => {
					this.back()
				}).catch(err => this.isLoading = true)
			},
			validationRule() {
				let isValidation = []
				if (this.accountRequest.roleId == "") {
					this.validationData.roleId = "ခွင်ပြုချက် ဖြည့်ပါ။"
					isValidation.push(true)
				} else {
					this.validationData.roleId = ""
					isValidation.push(false)
				}
				if (this.accountRequest.shopId == "") {
					this.validationData.shopId = "ဆိုင်ခွဲ ဖြည့်ပါ။"
					isValidation.push(true)
				} else {
					this.validationData.shopId = ""
					isValidation.push(false)
				}
				if (this.accountRequest.name == "") {
					this.validationData.name = "အကောင့်နာမည် ဖြည့်ပါ။"
					isValidation.push(true)
				} else {
					this.validationData.email = ""
					isValidation.push(false)
				}
				if (this.accountRequest.email == "") {
					this.validationData.email = "အီးမေးလ် ဖြည့်ပါ။"
					isValidation.push(true)
				} else {
					this.validationData.email = ""
					isValidation.push(false)
				}
				if(this.accountRequest.id == ""){
                    if(this.accountRequest.password == ""){
                        this.validationData.password = "လျှို့ဝှက်စကား ဖြည့်ပါ။"
                        isValidation.push(true)
                    }else{
                        this.validationData.password = ""
                        isValidation.push(false)
                    }
                    if(this.accountRequest.confirm == ""){
                        this.validationData.confirm = "လျှို့ဝှက်စကား နောက်တစ်ကြိမ် ဖြည့်ပါ။"
                        isValidation.push(true)
                    }else{
                        this.validationData.confirm = ""
                        isValidation.push(false)
                    }
                    if(this.accountRequest.password != this.accountRequest.confirm){
                        this.validationData.confirm = "လျှို့ဝှက်စကား မတူညီပါ။"
                        isValidation.push(true)
                    }else{
                        this.validationData.confirm = ""
                        isValidation.push(false)
                    }
                }
				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
			this.filter.page = this.$route.query.page
            this.filter.reverse = this.$route.query.reverse
            this.filter.sort = this.$route.query.sort
            this.filter.name = this.$route.query.name
			this.accountRequest.id = this.$route.query.id
			this.getFields()
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>